import { FileInfo, FileInfoProps } from "ui/core";

import { useLazyFileQuery } from "API";

const FileInfoWithFetcher: React.FC<FileInfoProps & { fileId?: string }> = ({
  fileId,
  disabled,
  ...rest
}) => {
  const [getUploadedFile, { isLoading: isFetchingFile }] = useLazyFileQuery();

  const handleClick = async () => {
    if (disabled) {
      return;
    }

    if (rest.onClick) {
      rest.onClick();
    } else if (fileId) {
      const res = await getUploadedFile(fileId);
      if (res.data?.file) {
        window.open(res.data.file);
      }
    } else if (rest.url) {
      window.open(rest.url);
    }
  };

  return (
    <FileInfo
      onClick={handleClick}
      loading={isFetchingFile}
      disabled={disabled}
      {...rest}
    />
  );
};

export default FileInfoWithFetcher;
